// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import FAQSection from '@spotahome/ui-library/src/tenant/components/FAQSection';

import { getTenantFaq } from '@spotahome/landings-common/src/utils/faq';

import Hero from './Hero';

const Content = () => {
  return (
    <>
      <Hero />
      <div>
        <FAQSection questions={getTenantFaq()} />
      </div>
    </>
  );
};

export default Content;
